import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';

import { BaseButton, useT } from '@repo/common';

import { ReactComponent as ArrowBottomIcon } from '@repo/common/assets/icons/20px/icon_20px_arrow-bottom.svg';
import { ReactComponent as ArrowTopIcon } from '@repo/common/assets/icons/20px/icon_20px_arrow-top.svg';
import { ReactComponent as CheckIcon } from '@repo/common/assets/icons/16px/icon_16px_check.svg';

const SortByFilterModal = ({
  initialSort,
  appliedSort,
  isOpen,
  setIsOpen,
  onChange,
}) => {
  const t = useT();
  const [sortBy, setSortBy] = useState(initialSort);
  const [dropdownCoords, setDropdownCoords] = useState(null);
  const sortButtonRef = useRef(null);

  const sortOptions = ['Most Relevant', 'Most Popular', 'Newest', 'Oldest'];
  const sortLabelsKr = {
    'Most Relevant': '관련도순',
    'Most Popular': '인기순',
    Newest: '최신순',
    Oldest: '오래된순',
  };

  const handleSortButtonClick = (e) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    setSortBy(initialSort);
  }, [initialSort]);

  const getBorderClass = () => {
    if (sortBy !== appliedSort) return 'border-grayscale-gray07';
    if (isOpen) return 'border-grayscale-gray07';
    return 'border-grayscale-gray03';
  };

  useEffect(() => {
    if (!isOpen) return;

    const updatePosition = () => {
      if (sortButtonRef.current) {
        const rect = sortButtonRef.current.getBoundingClientRect();
        setDropdownCoords({
          top: rect.bottom,
          left: rect.left,
          width: rect.width,
        });
      }
    };

    updatePosition();
    window.addEventListener('scroll', updatePosition);
    window.addEventListener('resize', updatePosition);

    return () => {
      window.removeEventListener('scroll', updatePosition);
      window.removeEventListener('resize', updatePosition);
    };
  }, [isOpen]);

  return (
    <>
      <button
        ref={sortButtonRef}
        onClick={handleSortButtonClick}
        className={`
          sort-filter-button
          w-full h-12 px-4 flex justify-between items-center
          rounded-[8px] typo-16 border ${getBorderClass()}
        `}
      >
        {t(sortBy, sortLabelsKr[sortBy] ?? sortBy)}
        {isOpen ? <ArrowTopIcon /> : <ArrowBottomIcon />}
      </button>

      {isOpen &&
        dropdownCoords &&
        ReactDOM.createPortal(
          <ul
            className='filter-modal-container fixed z-[9999] p-2 bg-white border border-grayscale-gray02
            rounded-[8px] shadow-[0_0_6px_rgba(104,101,97,0.08)]'
            style={{
              top: dropdownCoords.top + 8,
              left: dropdownCoords.left,
              width: dropdownCoords.width,
            }}
          >
            {sortOptions.map((option) => (
              <li key={option} className='h-[38px] flex items-center'>
                <BaseButton
                  type='text'
                  width='100%'
                  bgclass='bg-grayscale-gray00 border-none h-full min-h-[38px] p-0'
                  textclass='justify-start h-full'
                  hoverclass='hover:bg-grayscale-gray01 hover:text-text-primary'
                  activeclass='active:bg-grayscale-gray01 active:text-text-primary'
                  icon={
                    <CheckIcon
                      className={`ml-2 ${
                        sortBy === option ? 'opacity-100' : 'opacity-0'
                      }`}
                    />
                  }
                  leftalign='true'
                  onClick={() => {
                    setSortBy(option);
                    onChange(option);
                    setIsOpen(false);
                  }}
                >
                  {t(option, sortLabelsKr[option] ?? option)}
                </BaseButton>
              </li>
            ))}
          </ul>,
          document.body
        )}
    </>
  );
};

export default SortByFilterModal;
